<template>
  <div class="app">
    <!-- set progressbar -->
    <vue-progress-bar></vue-progress-bar>
    <Toastr ref="toastr"></Toastr>
    <div class="app-body">
      <Sidebar :navItems="nav"></Sidebar>
      <main 
        class="main"
      > 
        <AppHeader />
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <!--<AppAside/>-->
    </div>
    <AppFooter />
    <!--<AppFooter/>-->
    <EventModal></EventModal>
    <v-dialog @closed="beforeDialogClose" />
  </div>
</template>

<script>
import Toastr from "vue-toastr";
import { mapGetters } from "vuex";
import nav from "../_admin-nav";
import {
  Header as AppHeader,
  Aside as AppAside,
  Footer as AppFooter,
  Breadcrumb
} from "../components/";
import Sidebar from "../components/admin/Sidebar";
import { EventBus } from "../event-bus";
import EventModal from "../components/modal/Modal";

import routerKeys from "../store/router-keys";
import constants from "@/_consts";

import {
  EVENT_TOAST_MESSAGE,
  EVENT_ERROR_TOAST_MESSAGE,
  EVENT_WARNING_TOAST_MESSAGE
} from "../store/events";

export default {
  name: "templateauthenticatedadmin",
  created() {
    EventBus.$on(
      EVENT_TOAST_MESSAGE,
      function(msg) {
        if (!this.$refs.toastr) return;
        this.$refs.toastr.s(msg);
      }.bind(this)
    );
    EventBus.$on(
      EVENT_ERROR_TOAST_MESSAGE,
      function(msg) {
        if (!this.$refs.toastr) return;
        this.$refs.toastr.e(msg);
      }.bind(this)
    );
    EventBus.$on(
      EVENT_WARNING_TOAST_MESSAGE,
      function(msg) {
        if (!this.$refs.toastr) return;
        this.$refs.toastr.w(msg);
      }.bind(this)
    );
  },
  components: {
    AppHeader,
    Sidebar,
    AppAside,
    AppFooter,
    Breadcrumb,
    Toastr,
    EventModal
  },
  data() {
    return {
      nav: nav,
      modalOptions: {
        title: "",
        message: ""
      },
      loading: false
    };
  },
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched;
    },
    ...mapGetters({
      isLoading: "isLoading"
    })
  },
  methods: {
    beforeDialogClose() {
      const token = sessionStorage.getItem(constants.LOCAL_STORE.accessToken);
      if (!token) {
        this.$router.push(routerKeys.login);
      }
    }
  },
  mounted: function() {},
  watch: {
    isLoading(newLoading) {
      if (newLoading) {
        this.$Progress.start();
      } else {
        this.$Progress.finish();
      }
    }
  }
};
</script>

<style scoped>
.app-body {
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/containers/TemplateAuthenticatedAdmin.vue